import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { ArrowCircleDownRight20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/ArrowCircleDownRight20Regular";

export function useMenuItem_VersionAppRej(selectedItems: any[], waitFor: boolean, setIsCMVersionAppRejModalOpen: (isCMVersionAppRejModalOpen: boolean) => void, isInOneDrive: boolean) {
    const languageStrings = React.useContext(LanguageContext);

    const userAccount = useSelector((state: RootState) => state.user.account);

    const onApproveRejectClick = React.useCallback(() => {
        setIsCMVersionAppRejModalOpen(true);
    }, [setIsCMVersionAppRejModalOpen]);

    const menuItem_VersionAppRej = React.useMemo(() => {
        const hasSelection = selectedItems?.length > 0;
        if (isInOneDrive || !hasSelection) {
            return null;
        }

        const userCanApproveAll = !selectedItems.some(x => x?.EffectiveBasePermissions?.canApproveItems === false);

        const userCanCancelCheckoutAll = !selectedItems.some(x => x?.EffectiveBasePermissions?.canCancelCheckout === false);

        const areAllItemsPending = selectedItems.every(item => item['_ModerationStatus.'] === '2');

        const areAllItemsCheckedOutByCurrentUser = selectedItems.every(item =>
            Array.isArray(item.CheckoutUser) &&
            item.CheckoutUser.length > 0 &&
            item.CheckoutUser.every(user => user.email === userAccount.username)
        );

        const containsFiles = selectedItems.some(x => !x.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder));

        const shouldShowMenuItem =
            userCanApproveAll &&
            userCanCancelCheckoutAll &&
            areAllItemsPending &&
            (areAllItemsCheckedOutByCurrentUser || userCanCancelCheckoutAll) &&
            containsFiles;

        if (shouldShowMenuItem) {
            return {
                key: 'approveReject',
                disabled: waitFor === true,
                text: `${languageStrings.Approve}/${languageStrings.Reject}`,
                // iconProps: { iconName: "CheckedOutByOther12" },
                iconProps: {},
                onRenderIcon: () => <ArrowCircleDownRight20Regular className={menuItemIconStyles} />,
                onClick: onApproveRejectClick,
            } as IContextualMenuItem;
        }

        return null;
    }, [selectedItems, waitFor, isInOneDrive, userAccount.username, languageStrings, onApproveRejectClick]);

    return {
        menuItem_VersionAppRej
    };
}